import _ from 'lodash';
import angular from 'angular';
import { StateService } from '@uirouter/core';
import { APPLICATION_SIZE_MODES } from '../../constants';
import setTabNavRoles from '../../helpers/tab-nav-roles';

class ProjectCtrl {
  constructor($scope, ProjectService, FeedStore, $state: StateService, $timeout: ng.ITimeoutService, $element, $window) {
    const ctrl: ng.IController = this;
    ctrl.tabs = ['suggested', 'all', 'urgent'];
    $scope.groups = {};
    $scope.filterProject = {};

    ctrl.calculateBgStyle = () => {
      let resUrl = ctrl.headerData.data.unauthCoverBg.small;
      if ($window.innerWidth >= APPLICATION_SIZE_MODES.WIDE) {
        resUrl = ctrl.headerData.data.unauthCoverBg.wide;
      } else if ($window.innerWidth >= APPLICATION_SIZE_MODES.MEDIUM) {
        resUrl = ctrl.headerData.data.unauthCoverBg.medium;
      }
      $scope.unauthHeaderBg = resUrl;
    };

    ctrl.$onInit = () => {
      $scope.currentUser = ctrl.user;
      $scope.headerData = ctrl.headerData.data;
      $scope.coverBg = ctrl.coverBg;
      $scope.availableCountries = ctrl.projectInfo.countries;
      $scope.availableOSs = ctrl.projectInfo.os;

      $scope.filterProject = sanitizeFilters(ctrl.$transition$.params());
      if ($scope.filterProject.country && !findCountry($scope.filterProject.country)) {
        delete $scope.filterProject.country;
        ctrl.updateUrl();
      }

      setupFeed();
      let tab = ctrl.$transition$.params().tab || 'suggested';
      if (($scope.filterProject.os || $scope.filterProject.country) && tab === 'suggested') {
        tab = 'all';
      }
      $scope.selectTab(tab);

      ctrl.calculateBgStyle();
      angular.element($window).on('resize', () => {
        ctrl.calculateBgStyle();
      });
    };

    ctrl.$onDestroy = () => {
      angular.element($window).off('resize');
    };

    $scope.selectTab = (tab: string) => {
      $scope.tab = tab;

      ctrl.setActiveTab($scope.tab);
      setTabNavRoles(document.getElementsByClassName('nav-tabs'));

      $scope.groups[$scope.tab].loadOnce();
      ctrl.updateUrl();
    };

    ctrl.updateFilter = (type) => {
      const { country, os } = $scope.filterProject;
      ctrl.setAriaLabelForDropdown(type, type === 'os' ? os : country);
      setupFeed();
      if ($scope.tab === 'suggested') {
        $scope.selectTab('all');
      } else {
        $scope.groups[$scope.tab].loadOnce();
        ctrl.updateUrl();
      }
      // Selecting an option (or clearing one via Backspace) closes the dropdown and would
      // otherwise leave focus on document body, skipping the rest of the filter section on
      // the next Tab press. Return focus to the dropdown's toggle so keyboard users stay put.
      $timeout(() => {
        $element.find(`#${type}Dropdown .ui-select-focusser`).focus();
      });
    };

    ctrl.clearFilter = (type) => {
      $scope.filterProject[type] = null;
      ctrl.updateFilter(type);
    };

    ctrl.setAriaLabelForDropdown = (type, text) => {
      const container = $element.find(`#${type}Dropdown.ui-select-container`);
      // if no text provided then we need to add the placeholder text
      if (!text) {
        const placeholderText = type === 'os' ? 'Select an OS' : 'Select a country';
        angular.element(container).find('.ui-select-focusser').attr('aria-label', placeholderText);
        return;
      }
      angular.element(container).find('.ui-select-focusser').attr('aria-label', text);
    };

    const findCountry = country => (
      ($scope.availableCountries || []).find(s => s.toUpperCase() === country.toUpperCase())
    );

    const setupFeed = (resetAll = false) => {
      const fetchFeed = _.bind(ProjectService.feed, ProjectService);
      const sort = '-updated_at';
      if (resetAll || !$scope.groups.suggested) {
        setupSuggestedFeed(fetchFeed, sort);
      }

      const filters = { state: 'published', ...sanitizeFilters() };
      $scope.groups.all = FeedStore.create(fetchFeed, { filter: filters, sort });
      $scope.groups.urgent = FeedStore.create(fetchFeed, { filter: { ...filters, urgent: true }, sort });
    };

    const setupSuggestedFeed = (fetchFeed, sort) => {
      $scope.groups.suggested = FeedStore.create(
        fetchFeed,
        { filter: { state: 'published', suggested_projects: true }, sort },
      );
      $scope.groups.suggested.loadOnce().then(() => {
        if ($scope.tab === 'suggested' && !$scope.shouldShow('suggested')) {
          $scope.selectTab('all');
        }
      });
    };

    const sanitizeFilters = ({ os, country } = $scope.filterProject) => {
      const filters = {};
      // @ts-ignore
      if (os) filters.os = os;
      // @ts-ignore
      if (country) filters.country = findCountry(country);

      return filters;
    };

    $scope.loadMoreItems = (feedGroup) => {
      const nextIdx = feedGroup.feedItems.length;
      feedGroup.loadMore().then((res) => {
        const nextElem = res.feedItems[nextIdx];
        if (nextElem !== undefined && nextElem.id !== undefined) {
          $timeout(() => {
            const renderedElem = $(`#project_title_${nextElem.id}`)[0];
            if (renderedElem !== undefined) {
              renderedElem.focus();
            }
          });
        }
      });
    };

    $timeout(() => {
      const { country, os } = $scope.filterProject;
      ctrl.setAriaLabelForDropdown('country', country);
      ctrl.setAriaLabelForDropdown('os', os);
      const container = $element.find('.ui-select-container');
      if (container.length > 0) {
        _.forEach(container, (elem) => {
          const txt = angular.element(elem).find('.ui-select-match').attr('placeholder');

          angular.element(elem).find('.ui-select-search').removeAttr('aria-label');
          angular.element(elem).find('.ui-select-match').attr('aria-label', txt);
          angular.element(elem).find('.ui-select-toggle').attr('aria-label', txt);

          // find the remove / clear button and set tabindex to 0
          // so it can be focused with keyboard
          // role="button" is required because this is an <a> without an href, which
          // browsers otherwise expose with no implicit role — without it, screen readers
          // fall back to announcing the parent dropdown's label instead of this control's
          // own aria-label ("Select box clear") when it receives focus
          angular.element(elem).find('.btn-link').attr('tabindex', '0').attr('role', 'button');

          // add keydown event to the remove / clear button
          // so it can be clicked with keyboard (Enter or Space)
          // and focus is returned to the select element since it gets hidden after clearing
          angular.element(elem).find('.btn-link').on('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              (event.target as HTMLElement).click();
              angular.element(elem).find('.ui-select-focusser').trigger('focus');
            }
          });

          // mouse users clicking the clear button hit the same focus-loss issue as the
          // keyboard path above, so restore focus here too
          angular.element(elem).find('.btn-link').on('click', () => {
            angular.element(elem).find('.ui-select-focusser').trigger('focus');
          });
        });
      }
    }, 250);

    ctrl.setActiveTab = (tab: string) => {
      // @ts-ignore
      ctrl.tabStates = Object.fromEntries(ctrl.tabs.map(type => [type, false]));
      ctrl.tabStates[tab] = true;
    };

    ctrl.updateUrl = () => {
      const { country, os } = $scope.filterProject;
      $state.go('project', { tab: $scope.tab, country, os }, { location: 'replace' });
    };

    $scope.shouldShow = tab => {
      if (tab === 'suggested') {
        return $scope.groups.suggested.feedItems.length > 0 && !$scope.filterProject.os && !$scope.filterProject.country;
      }

      return true;
    };
  }
}

ProjectCtrl.$inject = [
  '$scope', 'ProjectService', 'FeedStore', '$state', '$timeout',
  '$element', '$window',
];

export default ProjectCtrl;
